<template>
  <fvSelect class="form-control select text-right fv-size-md"
            v-model="valData"
            :options="options"
            :placeholder="placeholder"
            text-key="name"
            value-key="id"
            :search="true"
  >

    <template slot="value" slot-scope="scope">
      {{findValueObject(scope.value).name}}
    </template>


    <template slot="option" slot-scope="scope">
      <div dir="ltr" class="text-left">
        <b>{{ scope.option.name }}</b>
        <span> (+{{ scope.option.code }})</span>
      </div>
    </template>

  </fvSelect>
</template>

<script>
  import {mapActions} from "vuex"
  import {API_MEDIA_URL} from "../env"

  export default {
    props: {
      placeholder: {
        type: String
      },
      id: {
        type: String
      },
      value: {
        type: String,
        default: undefined
      },
      required: [Boolean, Function],
    },
    data() {
      return {
        ...mapActions('main', [
          'crud'
        ]),
        options: [],
        media_url: API_MEDIA_URL
      }
    },
    created() {
      this.getData()
    },
    computed: {
      valData: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    },
    methods: {
      findValueObject(value) {
        return this.options.find((option) => option.id === value) || false;
      },
      async getData() {
        try {
          const countries = await this.crud({
            action: 'get',
            section: 'countries',
            perPage: 999
          })
          if (countries.data && countries.data.items) {
            const result = countries.data.items
            this.options = result
          }
        } catch (e) {
          console.log(e)
        }
      }
    }
  }
</script>

<style lang="scss">

</style>
